import { z } from 'zod';
import { LowercaseUuidSchema } from './common.js';
/** A rendered page resolves only the people it displays. */
export const USER_NAME_IDS_MAX = 100;
export const UserNamesQuerySchema = z.strictObject({
    ids: z.string()
        .transform((value) => value.split(',').map((id) => id.trim()))
        .pipe(z.array(LowercaseUuidSchema).min(1).max(USER_NAME_IDS_MAX)),
});
export const UserNamesResponseSchema = z.object({
    users: z.array(z.object({ id: z.string(), name: z.string() })),
});
